import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingConstants, OrderingOperations, OrderingSelectors } from 'polygon-ordering';
import { setCurrentModal } from './setCurrentModal';
import i18next from 'i18next';
import { CONFIRM_CHANGES_MODAL_ID } from '../modals/ConfirmChangesModal';
import type { RootState } from 'store';
import { DELIVERY_DETAILS_MODAL_ID } from '../modals/DeliveryDetailsModal';

const { DELIVERY_SALE_TYPES } = OrderingConstants;

const { removeStagedPurchase, validateFutureMenuItems: validateFutureMenuItemsPO } =
  OrderingOperations;

const { getSaleType, getBypassDeliveryDetails } = OrderingSelectors;

export const validateFutureMenuItems = createAsyncThunk(
  'validateFutureMenuItems',
  async (_data: undefined, { dispatch, getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const desiredDeliveryTime = state.desiredDeliveryTime;
      const saleType = getSaleType(state);
      const bypassDeliveryDetails = getBypassDeliveryDetails(state);

      const isDeliverySaleType = saleType && DELIVERY_SALE_TYPES.includes(saleType);

      dispatch(
        validateFutureMenuItemsPO({
          desiredDeliveryTime,
          onInvalidItemsExists: ({ invalidItems, proceedWithChosenTime }) => {
            dispatch(
              setCurrentModal({
                modalId: CONFIRM_CHANGES_MODAL_ID,
                params: {
                  title: i18next.t('confirmChanges.title'),
                  message: i18next.t('confirmChanges.subtitle'),
                  previousChangesTitle: i18next.t('confirmChanges.previousChangesTitle'),
                  currentChangesTitle: i18next.t('confirmChanges.currentChangesTitle'),
                  confirmChangesTitle: i18next.t('confirmChanges.subsectionTitle'),
                  confirmChangesDescription: i18next.t(
                    'confirmChanges.confirmChangesSubsectionDescription',
                  ),
                  changesBreakdown: invalidItems,
                  buttonText: i18next.t('button.confirm'),
                  action: () => {
                    if (invalidItems && Array.isArray(invalidItems)) {
                      invalidItems.map(item => dispatch(removeStagedPurchase(item.id)));
                    }

                    proceedWithChosenTime();

                    if (!isDeliverySaleType) {
                      dispatch(setCurrentModal(null));
                    } else {
                      dispatch(
                        setCurrentModal({
                          modalId: DELIVERY_DETAILS_MODAL_ID,
                          params: {
                            allowRedirect: false,
                            showOnlyTime: bypassDeliveryDetails,
                            saleType,
                          },
                        }),
                      );
                    }
                  },
                },
              }),
            );
          },
        }),
      );
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
